import { Link } from "react-router-dom";
import { t } from "../utils/utils";

export function Footer() {
  return (
    <div className="footer">
      <div className="footerCont cont1">
        <div className="textList">
          <div className="head">{t.quickLinks}</div>
          <Link to="services">{t.services}</Link>
          <Link to="about">{t.aboutUs}</Link>
          <Link to="/?scroll=homeContacts">{t.contactUs}</Link>
        </div>
      </div>
    </div>
  );
}
